import "./buttonGeneric.css";

interface ButtonGenericProps {
  title?: string;
  colorTitle?: string;
  background?: string;
  style?: string;
  className?: string;
  img?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  ariaLabel?: string;
  onClick?: () => void;
}

export const ButtonGeneric = ({
  title,
  colorTitle,
  background,
  img,
  style,
  className,
  disabled,
  type,
  ariaLabel,
  onClick,
}: ButtonGenericProps) => {
  const buttonStyle = {
    color: disabled ? "#FFF" : colorTitle,
    backgroundColor: background,
  };

  if (disabled) {
    buttonStyle.backgroundColor = "#979EA4";
  }

  return (
    <button
      type={type}
      style={buttonStyle}
      className={className || style}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel ?? title}
    >
      {img && <img src={img} width={15} className="imgIcone" alt="" />}
      {title && <span>{title}</span>}
    </button>
  );
};
